import { render } from "./HandbookView.vue?vue&type=template&id=46f24082&scoped=true"
import script from "./HandbookView.vue?vue&type=script&lang=js"
export * from "./HandbookView.vue?vue&type=script&lang=js"

import "./HandbookView.vue?vue&type=style&index=0&id=46f24082&scoped=true&lang=css"

import exportComponent from "/home/treim/code/applyhr/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f24082"]])

export default __exports__